import { useLanguage } from '@/hooks/Contexts'
import { Format } from '@/utils/Format'
import { ConsolationReward } from '@models/Index'
import { memo, useMemo, useState } from 'react'
import { ImgFallback } from '../Image'

const shortenString = (string: string, len: number, slice: number) => (string.length > len ? string.slice(0, slice) + '...' : string)

const InstantWinTicket = memo(function InstantWinTicket({ ticket, extraCls }: { ticket: ConsolationReward; extraCls?: string }) {
  const {
    competitions: { instant_win, cash, credit },
  } = useLanguage()
  const hasWon = useMemo<boolean>(() => !!ticket?.user_reward, [ticket?.user_reward])
  const [imgLoaded, setImgLoaded] = useState<-1 | 0 | 1>(0) // error | loading | loaded
  return (
    <div className={`relative inline-flex animate-fade-in-down items-center text-center ${extraCls || ''}`}>
      <div className={`absolute inset-0 flex h-full w-full flex-col justify-center align-middle transition-all duration-500 ${imgLoaded == 0 ? 'hidden' : ''}`}>
        <span className='inline-block text-xs font-semibold uppercase'>
          {hasWon ? shortenString(ticket.user_reward.user_firstname, 12, 12) + ', ' + ticket.user_reward.user_lastname.charAt(0) : instant_win}
        </span>
        <span className='text-2xl font-bold'>{ticket?.ticket_number}</span>
        <span className='text-xs'>
          {ticket.product ? (
            <ProductName name={ticket.product.name} />
          ) : ticket.alternative_cash_amount != '0.00' ? (
            Format.withCurrency(+ticket.alternative_cash_amount, ticket.currency) + ' ' + cash
          ) : (
            Format.withCurrency(+ticket.alternative_credit_amount, ticket.currency) + ' ' + credit
          )}
        </span>
      </div>
      <ImgFallback
        className='h-full w-full'
        src={hasWon ? '/assets/ticket_won.webp' : '/assets/ticket_available.webp'}
        fallbackSrc={hasWon ? '/assets/ticket_won.webp' : '/assets/ticket_available.webp'}
        onError={() => setImgLoaded(-1)}
        onLoad={() => setImgLoaded(prev => (prev == -1 ? -1 : 1))}
      />
    </div>
  )
})

const ProductName = ({ name }: { name: string }) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  return (
    <div
      className='cursor-pointer'
      onClick={() => setShowTooltip(prev => !prev)}
      onMouseOver={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span>{shortenString(name, 16, 13)}</span>
      <div className={`${showTooltip ? 'visible' : 'hidden'} absolute bottom-7 left-0 z-20 flex w-full justify-center text-center`}>
        <span
          className={`rounded-lg bg-stone-900/70 p-2 text-center text-sm text-white/100 after:absolute after:left-1/2 after:top-full after:border-8 after:border-transparent after:border-t-stone-900/70 after:content-['']`}
        >
          {name}
        </span>
      </div>
    </div>
  )
}

export default InstantWinTicket
